import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
};

function AddPromotion() {
    const [content, setContent] = useState("");
    const [image, setImage] = useState(null);
    const navigate = useNavigate();
    
    const handleImageUpload = async (e) => {
        const data = new FormData();
        data.append("image", e.target.files[0]);
        try {
            const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
            if (res?.image) {
                setImage(res.image);
                toast.success("Image uploaded successfully!");
            }
        } catch (error) {
            toast.error("Failed to upload image.");
            console.error("Error uploading image:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            content: content,
            image: image,
        };
        try {
            const res = await HomeService.addPromotion(data);
            if (res?.status) {
                toast.success("Promotion added successfully!");
                clearAddForm();
                navigate("/manage-promotion");
            }
        } catch (error) {
            // toast.error("Failed to add Promotion.");
            console.error("Error adding Promotion:", error);
        }
    };

    const clearAddForm = () => {
        setContent("");
        setImage(null);
    };

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">

                <div className="mt-5">
                <div style={headLineStyle}  className="page-headline">
                        Add Promotion
                    </div>
                    {/* <hr /> */}

                    <section
                     className="chartBox_area"
                     >
                      
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                            <div className="col-md-12 mt-3">
                                    <label htmlFor="cityImage">
                                        Image<span className="text-danger">*</span>
                                    </label>
                                    {image && (
                                    
                                        <img
                                            src={image}
                                            alt="Promotion"
                                            width="100"
                                            style={{ display: "block", marginTop: "10px", maxWidth:"100%" }}
                                        />
                                )}
                                    <input
                                        type="file"
                                        id="promotionImage"
                                        className="form-control"
                                        onChange={handleImageUpload}
                                        accept="image/*"
                                        required
                                    />
                                </div>
                                <div className="col-md-12 mt-3">
                                    <label htmlFor="name">
                                        Description<span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        type="text"
                                        id="content"
                                        className="form-control"
                                        value={content}
                                        onChange={(e) => setContent(e.target.value)}
                                        placeholder="Enter description"
                                        required
                                    />
                                </div>
                                
                                
                            </div>
                            <button
                                type="submit"
                                className="btn mt-3"
                                style={{
                                    background:'rgb(133, 218, 79)',
                                    borderRadius:'13px'
                                }}
                            >
                                Add Promotion
                            </button>
                        </form>





                       
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddPromotion;
